import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import MainCard from "../components/MainCard.vue";
import { GetTopBookmarks } from "../http/index";
import { ref,watch } from "vue";
import { Calendar, Search } from '@element-plus/icons-vue'
import 'animate.css'
import { id, tr } from "element-plus/es/locale";
import { ElMessage } from "element-plus";



export default /*#__PURE__*/_defineComponent({
  __name: 'TopMain',
  setup(__props) {

const Book = ref();
const GetBook = async () => {
  try {
     Book.value = (await GetTopBookmarks()).data;
  } catch (error) {
    ElMessage.error(`error:${error.message}`)
  }
};

GetBook();

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_component_el_row, { gutter: 12 }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Book.value, (item, index) => {
        return (_openBlock(), _createBlock(_component_el_col, {
          span: 6,
          style: {"margin-top":"10px"},
          key: "index",
          class: "animate__animated h"
        }, {
          default: _withCtx(() => [
            _createVNode(MainCard, {
              Book: item,
              onGetBook: GetBook
            }, null, 8, ["Book"])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}
}

})